import { ECOMemberPassIntegrationMutations } from './partials/eco-member-pass'
import { ECOPortalIntegrationCaseStatsMutations } from './partials/eco-portal-case-stats'
import { ECOPortalIntegrationMutations } from './partials/eco-portal'
import { KioskIntegrationMutations } from './partials/kiosk'
import { OWRIntegrationMutations } from './partials/owr'
import { SignupIntegrationMutations } from './partials/signup'
import { TmetricMutations } from './partials/tmetric'

export const IntegrationMutations = {
  ...ECOMemberPassIntegrationMutations,
  ...ECOPortalIntegrationCaseStatsMutations,
  ...ECOPortalIntegrationMutations,
  ...KioskIntegrationMutations,
  ...OWRIntegrationMutations,
  ...SignupIntegrationMutations,
  ...TmetricMutations,
}
